import { Link } from "react-router-dom";

const SECTIONS = [
  { t: "Private Intake", d: "Your intake is encrypted at rest and only visible to me. It is never shared, exported, or used for training. You may request deletion at any time — honored within 24 hours." },
  { t: "Consent, Ongoing", d: "Consent isn't a checkbox at booking. It is an ongoing conversation you can update, pause, or withdraw at any moment — before, during, or after the session." },
  { t: "Boundaries, Yours", d: "Bring the boundaries you already know. Discover more if they arrive. Nothing in a Rebel session is set until you set it." },
  { t: "Booking & Payments", d: "Payments run through Stripe. Charges appear as \"R&Co Consulting\" on your statement. We store only what refunds require." },
  { t: "Messaging & Journal", d: "Portal messages and journal entries are private. AI-assisted reflection prompts only run on entries you press \"Reflect\" on — nothing is otherwise sent, and nothing is used for training." },
  { t: "Communication Preferences", d: "You can set your preferred contact channel and how quiet you want everything to be. Email subject lines default to neutral, non-descriptive wording." },
  { t: "Aliases", d: "You may sign up under any name. We do not verify legal identity. We only ask that you confirm you are 21+." },
  { t: "Session Scope", d: "Rebel&Co is a private 1:1 practice. It is not therapy, not medical care, and not an escort service. Exact meeting details are shared privately with confirmed clients before the session." },
  { t: "Cancellation", d: "Full refund up to 7 days before your session — no questions. Every booking is pending my approval; if we're not a fit, you're fully refunded." },
  { t: "Age Requirement", d: "You must be 21+ to book or use the client portal." },
  { t: "Quick Exit", d: "The Exit button lives in the bottom-right of every page. One tap sends you to a neutral destination." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="font-body">
      <section className="pt-32 pb-14 sm:pt-40 sm:pb-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <span className="rc-eyebrow">Privacy · Boundaries · Consent</span>
          <h1 className="font-display text-4xl sm:text-6xl font-semibold mt-5" style={{ letterSpacing: "-0.03em", lineHeight: "1.05" }}>
            Private <span className="text-[#2d7cf6]">by design.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[color:var(--rc-text-muted)] max-w-xl leading-relaxed">
            What you explore is yours.
          </p>
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-10">
          {SECTIONS.map(x => (
            <section key={x.t}>
              <div className="text-xs font-semibold uppercase tracking-[0.1em] text-[#2d7cf6]">{x.t}</div>
              <p className="mt-3 text-base text-[color:var(--rc-text-muted)] leading-relaxed">{x.d}</p>
            </section>
          ))}
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <p className="text-base text-[color:var(--rc-text-muted)]">
            Privacy questions welcome — <Link to="/contact" className="text-[#2d7cf6] underline-editorial font-medium">start a private conversation.</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
